import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/styles'
import {
  CircularProgress,
  Divider,
  Link,
  Typography
} from '@material-ui/core'
import { ColorPaper } from '../Atoms'
import { Analytics } from '../../utils'
import { dutch } from '../../i18n/languages'

const useStyles = makeStyles(theme => ({
  paper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '10rem',
    padding: '1rem',
  },
  unorderedList: {
    listStyleType: 'disc',
    margin: 0,
  },
}))

const EnotLinks = ({ searchResult, showDefaultLink = false, loading = false }) => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()

  const linkObjects = {}
  if (!showDefaultLink && searchResult && searchResult.models) {
    searchResult.models.forEach(model => {
      const modelTreeData = model[`${i18n.language}_tree_data`]
      const category = modelTreeData['category']
      const section = modelTreeData['enot_section']

      if (linkObjects[category]) {
        linkObjects[category][section] = modelTreeData
      } else {
        linkObjects[category] = {
          [section]: modelTreeData,
          category_href: modelTreeData.category_href,
        }
      }
    })
  }

  return (
    <React.Fragment>
      <ColorPaper elevation={0} className={classes.paper}>
        <div>
          <Typography align="center" gutterBottom variant="body1">
            {t('links.title')}
          </Typography>
          <Divider variant="fullWidth" />
          <br />
          {showDefaultLink || (searchResult && searchResult.models.length === 0) ?
            <Typography variant="body2">
              <Link href={i18n.language === dutch ? 'https://portal.fednot.be/nl/modellen-en-clausules' : 'https://portal.fednot.be/fr/modeles-et-clauses'}
                target="_blank" onClick={() => Analytics.buttonClickEvent('Enotariaat link')}>{t('links.enot')}</Link>
            </Typography>
            : loading
              ? <div style={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></div>
              : Object.entries(linkObjects).map(([category, categoryObject]) => (

                <React.Fragment key={category}>
                  <Typography variant="body2">
                    <Link href={categoryObject.category_href} target="_blank" onClick={() => Analytics.buttonClickEvent('Enotariaat link')}>{category}</Link>
                  </Typography>
                  <ul className={classes.unorderedList}>
                    {Object.entries(categoryObject).map(([section, linkObject]) => (
                      linkObject.options && linkObject.options.map(option => (
                        <li key={option.subcategory ? option.subcategory : section}>
                          <Typography variant="body2">
                            <Link href={option.option_href} target="_blank" onClick={() => Analytics.buttonClickEvent('Enotariaat link')}>
                              {option.subcategory && option.subcategory + ' / '}{section}
                            </Link>
                          </Typography>
                        </li>
                      ))))}
                  </ul>
                </React.Fragment>
              ))}
          <br />
        </div>
      </ColorPaper>
    </React.Fragment>
  )
}

export default EnotLinks
